/**
 * An in-app link: a real anchor, so middle-click and cmd-click open a tab, with the
 * plain left click handled by the router instead of the network.
 */
import type { ComponentChildren } from "preact";

export function navigate(path: string): void {
  history.pushState({}, "", path);
  dispatchEvent(new PopStateEvent("popstate"));
}

export function Link({ href, class: cls, children }: { href: string; class?: string; children: ComponentChildren }) {
  return (
    <a href={href} class={cls} onClick={(e) => { if (e.metaKey || e.ctrlKey || e.button !== 0) return; e.preventDefault(); navigate(href); }}>
      {children}
    </a>
  );
}
